"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Workflow = void 0;
const Utilities_1 = require("../Utilities");
const ProdSysBase_1 = require("./ProdSysBase");
require("../../controls/Workflow/Workflow");
const WorkflowModel_1 = require("../../controls/Workflow/WorkflowModel");
class Workflow extends ProdSysBase_1.ProdSysBase {
    static Open(instance) {
        const instId = instance.id.valueAsString;
        let typeId = parseInt(instId.split("|")[2], 10);
        if (typeId === 999999950) {
            this.ShowWorkflow(instId, true, false);
            return new ProdSysBase_1.ActionResult(true, instId);
        }
        return new ProdSysBase_1.ActionResult(false, instId);
    }
    static View(instance) {
        const instId = instance.id.valueAsString + "|" + instance.items["cgdocument.version"].valueToString();
        this.ShowWorkflow(instId, false, true);
        return new ProdSysBase_1.ActionResult(true, instId);
    }
    static ShowWorkflow(instanceId, edit, colorizeWorkflow) {
        let markup = require("../../controls/Workflow/workflow.tmpl.html");
        // Create Window
        let windowData = Utilities_1.synUtil.popupWindow({
            title: "Workflow",
            actions: ["Maximize", "Close"],
            width: 1024,
            height: 768,
            minheight: 300,
            minwidth: 400,
            resizable: true,
            modal: true,
            synDesktopAware: true,
            preventCloseOnEscpae: true,
        });
        $("#" + windowData.windowID).data("kendoWindow").maximize();
        // Initialize contents
        let configData = {
            synUtil: Utilities_1.synUtil,
            windowID: "popup_" + windowData.guid,
            workFlowDesigner: "workFlowDesigner" + windowData.guid,
            saveButton: "saveButton" + windowData.guid,
        };
        // Needed so that bring to front of the popup window is not triggered
        $("#" + windowData.windowID).parent().off("mousedown");
        // Create HTML from template
        let template = kendo.template(markup);
        windowData.contentDiv.html(template(configData));
        $("#" + windowData.windowID).keydown((e) => {
            if (e.ctrlKey && (e.keyCode == 90 || e.keyCode == 89)) { // undo/redo 
                event.stopPropagation();
                event.preventDefault();
            }
        });
        Utilities_1.synUtil.getAJAXData({
            method: "POST",
            url: Utilities_1.synUtil.getWSUrl("WorkflowGetInstance"),
            requestData: JSON.stringify({ id: instanceId, checkout: edit }),
            done: function (workflow) {
                if (workflow) {
                    let workflowModel = WorkflowModel_1.WorkflowModel.fromJSON(workflow);
                    let workflowPane = $("#" + configData.workFlowDesigner);
                    workflowPane.synWorkflow();
                    $("#" + configData.saveButton).on("click", function () {
                        workflowPane.synWorkflow("saveWorkflow");
                    });
                    $("#" + configData.windowID).data("kendoWindow").bind("close", function (e) {
                        if (!workflowPane.synWorkflow("close", edit))
                            e.preventDefault();
                    });
                    workflowPane.on("closeWorkFlow", () => {
                        if (window.synDesktopApp != undefined) {
                            if (workflowPane.synWorkflow("close", edit))
                                window.synDesktopApp.endDialog("1");
                        }
                        else
                            $("#" + configData.windowID).data("kendoWindow").close();
                    });
                    if (edit)
                        workflowPane.synWorkflow("editWorkflow", workflowModel, instanceId, $("#" + windowData.windowID));
                    else
                        workflowPane.synWorkflow("viewWorkflow", workflowModel, colorizeWorkflow);
                }
            },
            fail: function (jqXHR, textStatus, errorThrown, url) {
                Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url, false);
                if (typeof window.synDesktopApp == "undefined")
                    $("#" + configData.windowID).data("kendoWindow").close();
            }
        });
    }
}
exports.Workflow = Workflow;
